import React, { useEffect, useRef, useState } from 'react'
import { withAuth } from '../AuthContext'
import { withRouter } from 'react-router-dom'
import { shouldTranslateTo } from '../../utils/utils'
import { SUCCESS } from '../../utils/constants'
import Notification from './../Utils/Notification'
import Form from 'react-bootstrap/Form'
import styled from 'styled-components'
import Error from '../Utils/Error'

import {
  Title,
  Subtitle,
  CustomSubtitle,
  ActionButtons,
  LoadingButton,
} from '../Utils/CustomClasses'

const queryParams = new URLSearchParams(window.location.search)

const OnboardingTitle = styled(Title)`
  font-family: 'Open Sans', sans-serif;
`

const OnboardingSubtitle = styled(Subtitle)`
  font-family: 'Open Sans', sans-serif;
`

const ContainerBox = styled.div`
  padding: 0 10vw 80px;
  background-color: transparent;

  @media (max-width: 799px) {
    padding: 25px 25px 25px 25px;
  }
`

const DashLineBox = styled.div`
  margin-top: 10px;
  padding: 30px 15px 40px;
  border-radius: 4px;
  border: 2px dashed #0bac5d;

  form {
    display: flex;
    justify-content: center;
    flex-direction: column;
    flex-wrap: nowrap;
    align-content: center;
    align-items: center;
    gap: 10px;
  }

  img {
    width: 350px;
    margin: 0 0 20px;
  }
`

const PhotoInput = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  input {
    width: 220px;
  }
`

const FileButton = styled(ActionButtons)`
  background-color: #fff;
  border: 1px solid #000;
  color: #000;
  margin: 10px auto 0;
  padding: 10px 10vw;
`

const CloseButton = styled(FileButton)`
  margin: 10px auto 20px;
  min-width: 330px;
`

const ChooseButton = styled(FileButton)`
  background-color: #e78b00;
  border: 0;
  color: #fff;
`
const ChooseButtonLater = styled(ChooseButton)`
  background-color: rgb(113, 113, 113);
  margin: 30px 0 0;
`

const ImageLoadingButton = styled(ActionButtons)`
  margin: 10px auto;
  padding: 10px 10vw;
`

const ImageIsLoadingButton = styled(LoadingButton)`
  margin: 10px auto;
  padding: 10px 10vw;
`

const ChangePhoto = styled(PhotoInput)`
  display: block;
`

const ButtonBox = styled.div`
  display: block;
  width: 100%;
`

const FormContent = styled.div`
  width: 50vw;
  min-width: 250px;
  text-align: center;

  @media screen and (max-width: 768px) {
    width: 100%;
  }

  button {
    width: -webkit-fill-available;
  }
`

const PriceChoiceBox = styled.div`
  background-color: transparent;
  border-radius: 10px;
  /*
  box-shadow: 0 5px 9px -2px #b5b5b5;
  border: 1px solid #eee;
  */
  margin: 40px 0 40px;
  width: 100%;
`

const FlexRowPrice = styled.div`
  display: flex;
  flex-direction: row;
  gap: 30px;
  align-items: top;
  justify-content: left;
  margin: 10px auto;
  width: 720px;

  @media (max-width: 799px) {
    flex-direction: column;
    margin-top: 20px;
    width: auto;

    & > div {
      width: -webkit-fill-available;
    }
  }
`

const PriceBoxHeaderBadgeContainer = styled.div`
  flex-basis: 40%;
  position: relative;
  padding: 0 20px 0 0;
  text-align: right;

  img {
    width: 230px;
  }

  @media (max-width: 799px) {
    display: none;
  }
`

const PriceBoxHeaderBadgeContaineMobile = styled(PriceBoxHeaderBadgeContainer)`
  display: none;
  padding: 0;
  text-align: center;

  img {
    width: 100%;
    max-width: 300px;
  }

  @media (max-width: 799px) {
    display: block;
  }
`

const InfoBox = styled.div`
  flex-basis: 60%;

  ul {
    width: 100%;
  }

  @media (max-width: 799px) {
    text-align: center;

    ul {
      margin: auto;
      padding-left: 22px;
      max-width: 360px;
    }
  }
`

const PriceBoxList = styled.ul`
  margin: 30px 1vw 40px;

  @media screen and (max-width: 799px) {
    margin: 0 7vw 40px;
  }
`

const PblI = styled.li`
  color: #fff;
  margin: 0 0 24px 20px;
  position: relative;
  text-align: left;

  &::before {
    content: url('images/onboarding/tick-green.svg');
    font-size: 20px;
    position: absolute;
    left: -30px;
    width: 24px;
  }
`

const SecurityIconContainer = styled.div`
  text-align: center;
  padding: 0 20px;

  img {
    width: 100%;
    max-width: 460px;
    margin: 30px 0 0;
  }
`

const ProofIdentityOnboarding = ({ data, onComplete, onUpdate }) => {
  const [responseMessage, setResponseMessage] = useState('')
  const [file, setFile] = useState(null)
  const [filePreview, setFilePreview] = useState(null)
  const [fileName, setFileName] = useState('')
  const [chooseDobDisplay, setChooseDobDisplay] = useState('block')
  const [choosePhotoDisplay, setChoosePhotoDisplay] = useState('block')
  const [chosenPhotoDisplay, setChosenPhotoDisplay] = useState('none')
  const [uploadButtonDisplay, setUploadButtonDisplay] = useState('none')
  const [changePhotoDisplay, setChangePhotoDisplay] = useState('none')
  const [uploadNewId, setUploadNewId] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [pageText, setPageText] = useState([])

  const hiddenFileInput = useRef(null)

  useEffect(() => {
    const language = shouldTranslateTo()
    const getPageText = (pageValue, languageValue) => {
      axios
        .get(`/api/page-text/${pageValue}/${languageValue}`)
        .then((response) => {
          let pageText = response.data.map((textItem) => {
            return textItem.text
          })

          setPageText(pageText)
        })
        .catch((err) => {
          console.log('Error getting page text: ', err)
        })
    }

    console.log('data: ' + JSON.stringify(data))

    getPageText('upload-photo-id', language)
  }, [])

  const handleClick = (e) => {
    e.preventDefault()
    hiddenFileInput.current.click()
  }

  const handleDoLater = (e) => {
    e.preventDefault()
    onComplete('db3')
  }

  const handleChange = (e) => {
    setFilePreview(URL.createObjectURL(e.target.files[0]))
    setFile(e.target.files[0])
    setFileName(e.target.files[0].name)
    setChoosePhotoDisplay('none')
    setChosenPhotoDisplay('block')
    setUploadButtonDisplay('flex')
    setChangePhotoDisplay('block')
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    setIsLoading(true)
    setResponseMessage('')

    const formData = new FormData()
    formData.append('file', file)
    const headers = {
      headers: {
        'content-type': 'multipart/form-data',
      },
    }

    axios
      .post('/api/upload-proof', formData, headers)
      .then(() => {
        Notification({
          type: SUCCESS,
          message: `${pageText[10]}`,
        })

        const photoIdDetails = {
          proofIdentityStatus: 'completed',
        }

        data.auth.updateUser(photoIdDetails)

        if (queryParams.get('s') === 'vf') {
          axios
            .get('/api/verify-account-status/proofidentityfromdashboard')
            .catch((err) => {
              console.log('Error getting account status: ', err)
            })

          window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
        }

        onComplete('db3')
      })
      .catch((e) => {
        setResponseMessage(`${pageText[11]}`)
      })
      .finally(() => {
        setIsLoading(false)
      })
  }

  const handleUploadNew = () => {
    if (data.auth.user.dob !== '1968-01-01') {
      setChooseDobDisplay('none')
      setChoosePhotoDisplay('block')
    }
    setUploadNewId(true)
  }

  const handleClose = (e) => {
    e.preventDefault()
    onUpdate()
  }

  if (pageText.length === 0) {
    return (
      <div className="card-body text-center">
        <div
          className="spinner-border homestays-spinner"
          style={{ marginTop: '100px' }}
          role="status"
        >
          <span className="sr-only">{pageText[12]}</span>
        </div>
      </div>
    )
  }
  return (
    <ContainerBox>
      {data.auth.user.proofIdentityStatus === 'completed' &&
      uploadNewId === false ? (
        <>
          <OnboardingTitle
            center
            color="#ff9900"
            size="34px"
            sizemd="34px"
            sizesm="34px"
            margin="10px 0 0"
            dangerouslySetInnerHTML={{
              __html: `${pageText[7]}`,
            }}
          ></OnboardingTitle>

          <OnboardingSubtitle
            color="#fff"
            center
            size="21px"
            sizesm="21px"
            weight="400"
            margin="10px 0 30px"
            dangerouslySetInnerHTML={{
              __html: `${pageText[8]}`,
            }}
          ></OnboardingSubtitle>

          <DashLineBox>
            <CloseButton onClick={(e) => handleClose(e)}>
              {pageText[25]}
            </CloseButton>
          </DashLineBox>
        </>
      ) : (
        <>
          <OnboardingTitle
            center
            color="#ff9900"
            size="34px"
            sizemd="34px"
            sizesm="34px"
            margin="10px 0 0"
            dangerouslySetInnerHTML={{
              __html: `${queryParams.get('s') === 'vf' ? pageText[26] : pageText[27]}`,
            }}
          ></OnboardingTitle>

          <OnboardingSubtitle
            center
            color="#fff"
            size="24px"
            sizesm="24px"
            weight="700"
            margin="10px 0 30px"
            dangerouslySetInnerHTML={{
              __html: `${queryParams.get('s') === 'vf' ? pageText[28] : pageText[29]}`,
            }}
          ></OnboardingSubtitle>

          <PriceChoiceBox>
            <FlexRowPrice>
              <PriceBoxHeaderBadgeContainer>
                <img src={'images/onboarding/icon-id-open-blue.png'} />
              </PriceBoxHeaderBadgeContainer>

              <PriceBoxHeaderBadgeContaineMobile>
                <img src={'images/onboarding/icon-id-1.png'} />
              </PriceBoxHeaderBadgeContaineMobile>

              <InfoBox>
                <PriceBoxList>
                  <PblI>{pageText[30]}</PblI>
                  <PblI>{pageText[31]}</PblI>
                  <PblI>{pageText[32]}</PblI>
                  <PblI>{pageText[33]}</PblI>
                  <PblI>{pageText[34]}</PblI>
                </PriceBoxList>
              </InfoBox>
            </FlexRowPrice>
          </PriceChoiceBox>

          <DashLineBox>
            <form
              method="POST"
              action="/"
              name="myForm"
              aria-label="Verify photo"
              onSubmit={(event) => {
                event.preventDefault()
                handleSubmit(event)
                return false
              }}
            >
              <input
                type="hidden"
                name="csrf-token"
                value={window.Laravel.csrfToken}
              />

              <FormContent style={{ display: choosePhotoDisplay }}>
                <Title
                  center
                  color="#fff"
                  size="21px"
                  sizemd="21px"
                  sizesm="21px"
                  margin="0 0 16px 0"
                  dangerouslySetInnerHTML={{
                    __html: `Please upload your ID document:`,
                  }}
                ></Title>
                <ChooseButton onClick={handleClick}>
                  {pageText[16]}
                </ChooseButton>
                <input
                  type="file"
                  onChange={(e) => handleChange(e)}
                  ref={hiddenFileInput}
                  style={{ display: 'none' }}
                />
              </FormContent>

              <Subtitle
                center
                color="#fff"
                weight="400"
                margin="0 0 15px"
                style={{ display: chosenPhotoDisplay }}
                dangerouslySetInnerHTML={{
                  __html: `<strong>${pageText[17]}</strong>`,
                }}
              />
              {chosenPhotoDisplay == 'block' ? (
                <img
                  src={filePreview}
                  style={{ width: '100%', maxWidth: '250px' }}
                />
              ) : (
                <>
                  {/*}
                  <Subtitle
                    center
                    color="#fff"
                    size="18px"
                    sizesm="18px"
                    weight="400"
                    margin="30px 60px 0 60px"
                    marginmd="30px 40px 0 40px"
                    marginsm="30px 20px 0 20px"
                    dangerouslySetInnerHTML={{
                      __html: `${pageText[24]}`,
                    }}
                  />

                  <Subtitle
                    center
                    color="#fff"
                    size="18px"
                    sizesm="18px"
                    weight="400"
                    margin="30px 60px 0 60px"
                    marginmd="30px 40px 0 40px"
                    marginsm="30px 20px 0 20px"
                    dangerouslySetInnerHTML={{
                      __html: `${pageText[1]}`,
                    }}
                  />
                  */}

                  <Subtitle
                    center
                    color="#fff"
                    size="18px"
                    margin="30px 60px 0 60px"
                    marginmd="30px 40px 0 40px"
                    marginsm="30px 20px 0 20px"
                    weight="400"
                    dangerouslySetInnerHTML={{
                      __html: `${pageText[6]}`,
                    }}
                  />

                  {!queryParams.get('s') && (
                    <ChooseButtonLater onClick={handleDoLater}>
                      {pageText[35]}
                    </ChooseButtonLater>
                  )}
                </>
              )}
              <ButtonBox>
                {isLoading ? (
                  <ImageIsLoadingButton padding="10px 9vw">
                    {pageText[18]}
                  </ImageIsLoadingButton>
                ) : (
                  <ImageLoadingButton
                    type="submit"
                    padding="10px 10vw"
                    style={{ display: uploadButtonDisplay }}
                  >
                    {pageText[19]}
                  </ImageLoadingButton>
                )}
              </ButtonBox>
              <ChangePhoto style={{ display: changePhotoDisplay }}>
                <Subtitle
                  center
                  color="#fff"
                  weight="400"
                  margin="10px 0 19px"
                  dangerouslySetInnerHTML={{
                    __html: `${pageText[23]}`,
                  }}
                />

                <FileButton onClick={handleClick}>{pageText[20]}</FileButton>
              </ChangePhoto>
            </form>
          </DashLineBox>

          <DashLineBox>
            <Subtitle
              center
              color="#fff"
              size="18px"
              sizesm="18px"
              weight="400"
              margin="30px 60px 0 60px"
              marginmd="30px 40px 0 40px"
              marginsm="30px 20px 0 20px"
              dangerouslySetInnerHTML={{
                __html: `${pageText[24]}`,
              }}
            />

            <SecurityIconContainer>
              <img src={'images/onboarding/icon-security.svg'} />
            </SecurityIconContainer>

            <Subtitle
              center
              color="#fff"
              size="18px"
              sizesm="18px"
              weight="400"
              margin="30px 60px 0 60px"
              marginmd="30px 40px 0 40px"
              marginsm="30px 20px 0 20px"
              dangerouslySetInnerHTML={{
                __html: `${pageText[1]}`,
              }}
            />
          </DashLineBox>
        </>
      )}

      <img
        src={
          'https://www.shareasale.com/sale.cfm?tracking=' +
          data.auth.user.id +
          '&amount=' +
          (Math.round(data.auth.user.membershipFee * 100) / 100).toFixed(2) +
          '' +
          '&currency=' +
          data.auth.user.currencyValue +
          '&merchantID=160393&transtype=sale&v=gtm_1.0'
        }
        width="1"
        height="1"
      />
    </ContainerBox>
  )
}

export default withRouter(withAuth(ProofIdentityOnboarding))
